import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const Home = () => {
    return (
        <div className="home-container">
            <section className="hero">
                <div className="hero-image">
                    <img src="https://i.imgur.com/WXR5tDb.jpg" alt="Hero banner" />
                </div>
                <h1>Welcome to Our Blog Platform</h1>
                <div className='common-spacer'>
                    <p className='common-para'>
                        Start sharing your thoughts and stories with the world. Our platform provides you a creative space to express yourself through blogs. Whether you're a seasoned writer or just starting out, this is the perfect place to connect and share your passions.
                    </p>
                </div>

                <Link to="/createblog" className="btn-primary">Create a Blog</Link>
            </section>
            <hr className="section-divider" />
            <section className="categories">
                <h2>Explore Different Categories</h2>
                <div className="info-banner common-para">
                    <p>Currently, we have not categorized our blogs. This is under process. Please feel free to explore all the site-wide blogs submitted by our bloggers community!!</p>
                    <Link to="/blogs" className="btn-primary">Explore all blogs</Link>
                </div>
                <div className="category-cards">
                    <div className="category-card">
                        <img src="https://cdn.pixabay.com/photo/2018/05/08/08/44/artificial-intelligence-3382507_1280.jpg" alt="Category 1" className="card-image" />
                        <h3>Technology</h3>
                        <p>Stay updated with the latest tech trends and innovations.</p>
                    </div>
                    <div className="category-card">
                        <img src="https://images.pexels.com/photos/1268855/pexels-photo-1268855.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="Category 2" className="card-image" />
                        <h3>Travel</h3>
                        <p>Discover amazing travel destinations and adventures.</p>
                    </div>
                    <div className="category-card">
                        <img src="https://images.pexels.com/photos/4122912/pexels-photo-4122912.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="Category 3" className="card-image" />
                        <h3>Food & Cooking</h3>
                        <p>Explore delicious recipes and culinary experiences.</p>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Home;
